import { convertArrayToCSV } from 'convert-array-to-csv';
import { getCommonReportFields, getExistingFilterFlags } from './services/reportFieldsService';

const prepareData = async (data, isBaseline, requestedReports) => {
  let preparedData = [];

  const { hasOhtFilter, hasDeviceClassesFilter } = getExistingFilterFlags(
    isBaseline,
    requestedReports
  );

  preparedData = data.map((pa, idx) => {
    const total = Math.max(
      ...pa.Practices.map(practice => practice.Satisfied + practice.Partial + practice.Deficient)
    );
    return pa.Practices.map(practice => {
      const dataPoint = getCommonReportFields(
        pa,
        requestedReports,
        idx,
        isBaseline,
        hasOhtFilter,
        hasDeviceClassesFilter
      );

      dataPoint[`Practice`] = `${practice.Name}`;
      const satisfied = practice.Satisfied || 0;
      const partial = practice.Partial || 0;
      const deficient = practice.Deficient || 0;

      if (total < 3) {
        dataPoint[`Satisfied`] = `N/A`;
        dataPoint[`Partial`] = `N/A`;
        dataPoint[`Deficient`] = `N/A`;
        dataPoint[`Total`] = `N/A`;
      } else {
        dataPoint[`Satisfied`] = satisfied;
        dataPoint[`Partial`] = partial;
        dataPoint[`Deficient`] = deficient;
        dataPoint[`Total`] = satisfied + partial + deficient;
      }

      return dataPoint;
    });
  });

  return preparedData.flat();
};

export const getPracticeAreaCharacterizationCSV = async (data, requestedReports) => {
  const isBaseline = !!data.baselineReport;
  data = isBaseline ? data.baselineReport.PracticeAreas : data.appraisalView.PracticeAreas;

  const preppedData = await prepareData(data, isBaseline, requestedReports);
  return convertArrayToCSV(preppedData);
};
